function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { node, string } from 'prop-types';
import clsx from 'clsx';
import DialogActions, { dialogActionsClasses } from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
const StyledActions = styled(DialogActions)(_ref => {
  let {
    theme: {
      spacing
    }
  } = _ref;
  return {
    margin: "".concat(spacing(), " 0 0 0"),
    padding: 0,
    ["&.".concat(dialogActionsClasses.spacing)]: {
      '& > :not(:first-of-type)': {
        marginInlineStart: spacing() // margin between action buttons
      }
    }
  };
});

/**
 * `SovosDialogActions` is a component to be used inside `SovosDialog` to
 * set up a dialog's actions.
 */
const SovosDialogActions = _ref2 => {
  let {
    className,
    children,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledActions, _extends({}, props, {
    className: clsx('sovosDialogActions', className)
  }), children);
};
SovosDialogActions.propTypes = {
  /**
   * The content of the dialog actions. Must be one or more `SovosButtons`
   */
  children: node,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
export default SovosDialogActions;